import childReport from '../pages/analytic/childReport.vue';
import AssessmentReport from '../pages/analytic/component/AssessmentReport.vue';

const routes = [
  { // /children/:id
    path: '/children/:id',
    component: childReport,
    name: 'child-report',
    meta:{
      name: 'Child Report',
      requireAuth: true
    },
    props: true
  },
  { // /children/:child_id/report/:trait_id
    path: '/children/:child_id/report/:trait_id',
    component: AssessmentReport,
    name: 'child-assessment-report',
    meta:{
      name: 'Child Assessment Report',
      requireAuth: true
    },
    props: true
  },
]

export default routes